<div class="ng-Header col-xs-12 col-md-12 col-lg-12">
  <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Dashboard
</div>
<div class="row">
  <div class="col-12 col-xl-7">
    <!--     Inspection Completed-->
    <div class="row">
      <div class="col-12 col-sm-6 stats-col" *ngIf="stpCounts?.totalStp > 0">
        <a
          routerLink="/home/stp-registration/stp-application/total-registered"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(127, 199, 151, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="hdd" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ stpCounts?.totalStp }}</h3>
                <span class="d-block">Total Registered STPs</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div class="col-12 col-sm-6 stats-col" *ngIf="stpCounts?.totalActiveStp > 0">
        <a
          routerLink="/home/stp-registration/stp-application/active-stps"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(127, 131, 199, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="check-square" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ stpCounts?.totalActiveStp }}</h3>
                <span class="d-block">Currently Active STPs</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-sm-6 stats-col" *ngIf="stpCounts?.expiredStp > 0">
        <a
          routerLink="/home/stp-registration/stp-application/expired-stps"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(199, 127, 152, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="exception" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ stpCounts?.expiredStp }}</h3>
                <span class="d-block">Total Expired STPs</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div class="col-12 col-sm-6 stats-col" *ngIf="stpCounts?.stpExpiresIn > 0">
        <a
          routerLink="/home/stp-registration/stp-application/expiring-soon-stps"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(199, 127, 127, 0.15)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="warning" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ stpCounts?.stpExpiresIn }}</h3>
                <span class="d-block">STPs Expiring in 3 Months</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.inspectionCompleted > 0"
      >
        <a
          [routerLink]="[
            '/home/course-accreditation/course-accreditation-inspector-list'
          ]"
          [queryParams]="{ applicationTypeId: 17 }"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: #e4f4ea"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="form" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.inspectionCompleted }}</h3>
                <span class="d-block">Inspection Completed</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.inspectionScheduled > 0"
      >
        <a
          [routerLink]="[
            '/home/course-accreditation/course-accreditation-inspector-list'
          ]"
          [queryParams]="{ applicationTypeId: 15 }"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: #e9e7e7"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.inspectionScheduled }}</h3>
                <span class="d-block"> Inspection Scheduled</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.inspectionDecisionCompleted > 0"
      >
        <a
          [routerLink]="[
            '/home/course-accreditation/course-accreditation-inspector-list'
          ]"
          [queryParams]="{ applicationTypeId: 20 }"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: #f6ebe7"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="file-done" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.inspectionDecisionCompleted }}</h3>
                <span class="d-block"> Inspection Decision Completed</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.inspectionScrutinyCompleted > 0"
      >
        <div
          class="single-stats-box d-md-flex align-items-center my-1"
          style="background-color: #cedde0ff"
        >
          <div class="d-flex justify-content-center bd-highlight mb-3">
            <div class="p-2 bd-highlight">
              <div class="icon">
                <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
              </div>
            </div>
            <div class="p-2 bd-highlight">
              <h3>{{ dashboardDetails?.inspectionScrutinyCompleted }}</h3>
              <span class="d-block"> Inspection Scrutiny Completed</span>
            </div>
          </div>
        </div>
      </div>
      <div
        [appRequiredPermission]="
          applicationPermissions.stpOperation.rplAssessment
            .issueCertificateButtonRpl
        "
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.rplCertIssuancePending > 0"
      >
        <a
          routerLink="/home/stp-operations/rpl/rpl-certificates-pending-assessment-app-list-view"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(127, 199, 151, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.rplCertIssuancePending }}</h3>
                <span class="d-block"> Pending RPL Certificates</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div
        [appRequiredPermission]="
          applicationPermissions.stpOperation.regularAssessment
            .issueCertificateButtonRegular
        "
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.regularCertIssuancePending > 0"
      >
        <a
          routerLink="/home/stp-operations/reg/regular-certificates-pending-assessment-app-list-view"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(127, 199, 151, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.regularCertIssuancePending }}</h3>
                <span class="d-block"> Pending Regular Certificates</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        [appRequiredPermission]="
          applicationPermissions.stpOperation.specialBatch
            .issueCertificateButtonSpecialBatch
        "
        class="col-12 col-sm-6 stats-col"
        *ngIf="dashboardDetails?.specialBatchCertIssuancePending > 0"
      >
        <a
          routerLink="/home/stp-operations/special-batch/sb-certificates-pending-assessment-app-list-view"
          target="_blank"
        >
          <div
            class="single-stats-box d-md-flex align-items-center my-1"
            style="background-color: rgba(127, 199, 151, 0.14)"
          >
            <div class="d-flex justify-content-center bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div class="icon">
                  <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
                </div>
              </div>
              <div class="p-2 bd-highlight">
                <h3>{{ dashboardDetails?.specialBatchCertIssuancePending }}</h3>
                <span class="d-block"> Pending Re-Assessment Certificates</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="col-12 col-xl-5">
    <app-calendar></app-calendar>
  </div>
</div>
